"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.LocaleData = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        globalContainer = window;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    NoIssuesMessage: function () { return t('@tableau__prediction-model-results-viz/NoIssuesMessage'); },
    IssuesDetectedMessage: function () { return t('@tableau__prediction-model-results-viz/IssuesDetectedMessage'); },
    ModelQualityCheck: function () { return t('@tableau__prediction-model-results-viz/ModelQualityCheck'); },
    DataAlerts: function () { return t('@tableau__prediction-model-results-viz/DataAlerts'); },
    Variable: function () { return t('@tableau__prediction-model-results-viz/Variable'); },
    Correlation: function () { return t('@tableau__prediction-model-results-viz/Correlation'); },
    CorrelationWithOutcome: function () { return t('@tableau__prediction-model-results-viz/CorrelationWithOutcome'); },
    GainsChart: function () { return t('@tableau__prediction-model-results-viz/GainsChart'); },
    Gain: function () { return t('@tableau__prediction-model-results-viz/Gain'); },
    CumulativeCaptureRate: function () { return t('@tableau__prediction-model-results-viz/CumulativeCaptureRate'); },
    CumulativeDataFraction: function () { return t('@tableau__prediction-model-results-viz/CumulativeDataFraction'); },
    NoModel: function () { return t('@tableau__prediction-model-results-viz/NoModel'); },
    ValidationSet: function () { return t('@tableau__prediction-model-results-viz/ValidationSet'); },
    Positive: function () { return t('@tableau__prediction-model-results-viz/Positive'); },
    Negative: function () { return t('@tableau__prediction-model-results-viz/Negative'); },
    Actual: function () { return t('@tableau__prediction-model-results-viz/Actual'); },
    Predicted: function () { return t('@tableau__prediction-model-results-viz/Predicted'); },
    FalsePositive: function () { return t('@tableau__prediction-model-results-viz/FalsePositive'); },
    FalseNegative: function () { return t('@tableau__prediction-model-results-viz/FalseNegative'); },
    TruePositive: function () { return t('@tableau__prediction-model-results-viz/TruePositive'); },
    TrueNegative: function () { return t('@tableau__prediction-model-results-viz/TrueNegative'); },
};
//# sourceMappingURL=Localize.js.map